import type { Components } from "@mui/material/styles";

export const MuiCheckbox: Components["MuiCheckbox"] = {};
